import { render, staticRenderFns } from "./VehicleOperationHoursStatistics.vue?vue&type=template&id=06652784&scoped=true&"
import script from "./VehicleOperationHoursStatistics.vue?vue&type=script&lang=js&"
export * from "./VehicleOperationHoursStatistics.vue?vue&type=script&lang=js&"
import style0 from "./VehicleOperationHoursStatistics.vue?vue&type=style&index=0&id=06652784&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06652784",
  null
  
)

export default component.exports